module.exports = __webpack_public_path__ + "static/media/b1_p15_clickable.d398d495.png";